export default {
    Metadata: {
        Name: "Today",
        Description: "Returns today\'s date (without the time).",
        Syntax: "Today()",
        Keywords: ['Date', 'Time'],
        Author: "DataVoke, Inc.",
    },
    execute() {
        return Date.today();
    },
};

